import { z } from "zod";
import { Id, NonEmpty } from "../../base";
import { QuestRecordSchema, QuestCreateSchema, QuestPatchSchema } from "./quest";
export const ChapterRecordSchema = z.strictObject({
    id: Id,
    title: NonEmpty,
    sequence: z.number(),
    quests: z.array(QuestRecordSchema),
});
export const ChapterCreateSchema = z.strictObject({
    title: NonEmpty,
    sequence: z.number(),
    quests: z.array(QuestCreateSchema),
});
export const ChapterPatchSchema = z.strictObject({
    id: Id,
    title: NonEmpty,
    sequence: z.number(),
    quests: z.array(QuestPatchSchema),
}).partial();
